<template>
  <!-- Sidebar -->
  <!--
    Sidebar Mini Mode - Display Helper classes

    Adding 'smini-hide' class to an element will make it invisible (opacity: 0) when the sidebar is in mini mode
    Adding 'smini-show' class to an element will make it visible (opacity: 1) when the sidebar is in mini mode
    If you would like to disable the transition animation, make sure to also add the 'no-transition' class to your element

    Adding 'smini-hidden' to an element will hide it when the sidebar is in mini mode
    Adding 'smini-visible' to an element will show it (display: inline-block) only when the sidebar is in mini mode
    Adding 'smini-visible-block' to an element will show it (display: block) only when the sidebar is in mini mode
    -->
  <nav id="sidebar" aria-label="Main Navigation">
    <slot>
      <!-- Side Header -->
      <div class="content-header bg-white-5">
        <!-- Logo -->
        <router-link
          :to="
            $route.params.collegeName
              ? `/backend/college/${$route.params.collegeName}/dashboard`
              : '/backend/dashboard'
          "
          class="font-w600 text-dual"
        >
          <span class="smini-visible">
            <i class="fa fa-circle-notch text-primary"></i>
          </span>
          <span
            class="smini-hide font-size-h5 tracking-wider"
            v-if="!$route.params.collegeName"
          >
            Aptitude Buster <span class="font-w400"></span>
          </span>
          <span
            class="smini-hide font-size-h5 tracking-wider text-capitalize"
            v-else
          >
            {{ $route.params.collegeName.split("-").join(" ") }}
            <span class="font-w400"></span>
          </span>
        </router-link>
        <!-- END Logo -->
      </div>
      <!-- END Side Header -->

      <!-- Sidebar Scrolling -->
      <simplebar class="js-sidebar-scroll">
        <!-- Side Navigation -->
        <div class="content-side" v-if="collegeType == 0">
          <base-navigation
            :nodes="$route.params.collegeName ? navigationCollege : navigation"
          ></base-navigation>
        </div>
        <div class="content-side" v-else-if="collegeType == 1">
          <base-navigation
            :nodes="$route.params.collegeName ? navigationCollege1 : navigation"
          ></base-navigation>
        </div>
        <div class="content-side" v-else-if="collegeType == 2">
          <base-navigation
            :nodes="$route.params.collegeName ? navigationCollege2 : navigation"
          ></base-navigation>
        </div>
        <div class="content-side" v-else-if="collegeType == 3">
          <base-navigation
            :nodes="$route.params.collegeName ? navigationCollege3 : navigation"
          ></base-navigation>
        </div>
        <!-- END Side Navigation -->
      </simplebar>
      <!-- END Sidebar Scrolling -->
    </slot>
  </nav>
  <!-- END Sidebar -->
</template>

<script>
// SimpleBar, for more info and examples you can check out https://github.com/Grsmto/simplebar/tree/master/packages/simplebar-vue
import simplebar from "simplebar-vue";

// Get navigation data
import menu from "@/data/menu";
export default {
  name: "BaseSidebar",
  props: {
    classes: String,
  },
  components: {
    simplebar,
  },
  mounted() {
    const menuList = menu();
    (this.navigation = menuList),
      (this.navigationCollege);
      (this.navigationCollege1);
      (this.navigationCollege2);
      (this.navigationCollege3);
      (this.collegeType);
  },

  data() {
    return {
      // Get main navigation
      navigation: [],
      collegeType: localStorage.getItem('collegeType') || '',
      navigationCollege: [
        // {
        //   name: 'Students List',
        //   to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/users`,
        //   icon: 'si si-speedometer'
        // },
        {
          name: 'Subscriptions',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/subscriptions`,
          icon: 'si si-menu'
        },
        {
          name: 'Departments',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/departments`,
          icon: 'si si-list'
        },
        {
          name: 'Hods',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/hods`,
          icon: 'si si-emotsmile'
        },
        {
          name: 'Classes',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/classes`,
          icon: 'si si-map'
        },
        {
          name: 'Students',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/students`,
          icon: 'si si-compass'
        },
        {
          name: 'Test Reports',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/test_reports`,
          icon: 'si si-check'
        }
      ],
      navigationCollege1: [
        // {
        //   name: 'Students List',
        //   to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/users`,
        //   icon: 'si si-speedometer'
        // },
        {
          name: 'Hods',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/hods`,
          icon: 'si si-emotsmile'
        },
        {
          name: 'Classes',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/classes`,
          icon: 'si si-map'
        },
        {
          name: 'Students',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/students`,
          icon: 'si si-compass'
        },
        {
          name: 'Test Reports',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/department_test_reports`,
          icon: 'si si-check'
        }
      ],
      navigationCollege2: [
        // {
        //   name: 'Students List',
        //   to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/users`,
        //   icon: 'si si-speedometer'
        // },
        {
          name: 'Classes',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/classes`,
          icon: 'si si-map'
        },
        {
          name: 'Students',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/students`,
          icon: 'si si-compass'
        },
        {
          name: 'Test Reports',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/hod_test_reports`,
          icon: 'si si-check'
        }
      ],
      navigationCollege3: [
        // {
        //   name: 'Students List',
        //   to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/users`,
        //   icon: 'si si-speedometer'
        // },
        {
          name: 'Students',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/students`,
          icon: 'si si-compass'
        },
        {
          name: 'Test Reports',
          to: `/backend/tables/college/${localStorage.getItem('collegeUrl')}/class_test_reports`,
          icon: 'si si-check'
        }
      ],
    };
  },
};
</script>
